module.exports = __webpack_public_path__ + "static/img/google_play_badge_bw.5514593.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/google_play_badge_bw.png
// module id = PG7h
// module chunks = 1